import { SupportedCurrency } from '@va/constants';
import { Website } from '@visitor-analytics/3as-sdk';

export type AaasSubscription = {
  id: string;
  status: string;
  packageId: string;
  websiteId?: string;
  intpId: string;
  intpcId: string;
  expiresAt: string;
  stpResetAt: string;
  lastPackageChangeAt: string;
  createdAt: string;
  billingInterval: string;
  type: string;
  inTrial: string;
  hadTrial: string;
  consumption: SubscriptionConsumption;
  plannedDowngradePackageId: string;
};

export type SubscriptionConsumption = {
  stpLimit: number;
  stpConsumed: number;
  stpRateVisit: number;
  stpConsumedVisit: number;
  stpRateVisitEvent: number;
  stpConsumedVisitEvent: number;
  stpRateSessionRecording: number;
  stpConsumedSessionRecording: number;
  stpRateHeatmapIncrement: number;
  stpConsumedHeatmapIncrement: number;
  stpRatePollAnswer: number;
  stpConsumedPollAnswer: number;
  stpRateSurveyAnswer: number;
  stpConsumedSurveyAnswer: number;
  stpConsumedFunnelMatch: number;
  stpRateFunnelMatch: number;
  stpRateEcomEvent?: number;
  stpConsumedEcomEvent?: number;
  stpConsumedAiQuery: number;
  stpRateAiQuery: number;
};

type PoolInfo = {
  id: string;
  intpId: string;
  intpcId: string;
  packageId: string;
  limit: number;
  consumed: number;
};

export type StpCounterResponse = {
  id: string;
  intpId: string;
  packageId: string;
  websiteId: string;
  poolId: string | null;
  pool: PoolInfo | null;
} & SubscriptionConsumption;

export enum FeatureName {
  ip2company = 'FEATURE_IP_2_COMPANY',
  customReports = 'FEATURE_CUSTOM_REPORTS',
  visitorSegments = 'FEATURE_VISITOR_SEGMENTS',
  customDashboards = 'FEATURE_CUSTOM_DASHBOARDS',
  countryBasedPrivacy = 'FEATURE_COUNTRY_BASED_PRIVACY_MODE',
  fullDataAccess = 'FEATURE_FULL_DATA_ACCESS',
  contentAnalysis = 'FEATURE_CONTENT_ANALYSIS',
  trendIntel = 'FEATURE_TREND_INTEL',
}

export type AaasFeaturePermission = {
  feature: FeatureName;
  minStps: number;
  enabled: boolean;
};

export type IntpUpgradeMessage = Pick<
  Website,
  'intpWebsiteId' | 'packageName' | 'packageId' | 'intpCustomerId' | 'inTrial' | 'expiresAt' | 'billingInterval'
>;

export type AaasPackage = {
  id: string;
  createdAt: string;
  excludedFeatures: Array<unknown>;
  externalId: string;
  intpId: string;
  name: string;
  period: 'monthly' | 'yearly';
  price: number;
  recommended: boolean;
  touchpoints: number;
  currency: SupportedCurrency;
};

export type GroupedPackages = {
  monthly: AaasPackage[];
  yearly: AaasPackage[];
};

export enum AaasBillingMode {
  PlatformManaged = 'platform_managed',
  CompanyManaged = 'company_managed',
}

export enum AaasSubscriptionType {
  Website = 'website',
  Intpc = 'intpc',
}

export enum AaasPackageVisibility {
  Public = 'public',
  // TODO: Make sure it's the correct value
  Private = 'private',
}

export type IntpWebsite = Website & {
  intpName: string;
  billingMode: AaasBillingMode;
  visaCustomerId: string;
  subscriptionType: AaasSubscriptionType;
  subscriptionId: string;
  previousPackage?: {
    id: string;
    name: string;
  };
};

export enum DashboardType {
  website = 'website',
  intpc = 'intpc',
}
